import React, { useMemo, useState } from "react";

import Header from "./FILTVHeader";
import LiveTicker from "./FILTVLiveTicker";
import "./FILTVLiveTicker.css";

import Sidebar from "./FILTVSidebar";
import ChannelStrip from "./FILTVChannelStrip";
import ChannelSheet from "./FILTVChannelSheet";

import VideoPlayer from "./FILTVVideoPlayer";
import NowPlaying from "./FILTVNowPlaying";
import BottomBar from "./FILTVBottomBar";

// import useFiltvData from "./useFiltvData";
// import { selectAdForChannel, buildChannelAvailability } from "./filtvHelpers";

import useFiltvChannels from "./useFiltvChannels";
import useFiltvNowPlaying from "./useFiltvNowPlaying";
import { CHANNEL_START } from "./filtvConstants";

const FILTV = ({ authState }) => {
    const { channels: availableChannels } = useFiltvChannels();
    const location = authState?.user?.location || {};
    const [activeLcn, setActiveLcn] = useState(CHANNEL_START);
    const [transitioning, setTransitioning] = useState(false);
    const [sheetOpen, setSheetOpen] = useState(false);

    const activeChannel =
        availableChannels.find((c) => c.lcn === activeLcn) || availableChannels[0];

    const { ad: nowPlayingAd, loading: adLoading } = useFiltvNowPlaying(activeLcn, location);

    const handleChannelChange = (channel) => {
        if (!channel || channel.lcn === activeLcn) {
            setSheetOpen(false);
            return;
        }

        setTransitioning(true);
        window.setTimeout(() => setActiveLcn(channel.lcn), 180);
        window.setTimeout(() => setTransitioning(false), 420);
        setSheetOpen(false);
    };

    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-br from-zinc-950 via-black to-purple-950 text-white">
            <Header user={authState?.user} />
            <LiveTicker />

            <div className="flex flex-col lg:flex-row flex-1 lg:gap-3 lg:p-3">
                {/* Desktop channel rail */}
                <div className="hidden lg:block lg:w-52 lg:shrink-0">
                    <Sidebar
                        channels={availableChannels}
                        activeLcn={activeLcn}
                        onSelect={handleChannelChange}
                        onMore={() => setSheetOpen(true)}
                    />
                </div>

                <div className="flex-1 flex flex-col gap-2 p-2 lg:p-0 min-w-0">
                    <VideoPlayer
                        channel={activeChannel}
                        ad={nowPlayingAd}
                        transition={transitioning}
                    />

                    <NowPlaying channel={activeChannel} ad={nowPlayingAd} />

                    {/* Mobile channel strip, thumb reach right under the player */}
                    <div className="lg:hidden">
                        <ChannelStrip
                            channels={availableChannels}
                            activeLcn={activeLcn}
                            onSelect={handleChannelChange}
                            onMore={() => setSheetOpen(true)}
                        />
                    </div>
                </div>
            </div>

            <BottomBar ad={nowPlayingAd} />

            <ChannelSheet
                open={sheetOpen}
                channels={availableChannels}
                activeLcn={activeLcn}
                onSelect={handleChannelChange}
                onClose={() => setSheetOpen(false)}
            />
        </div>
    );
};

export default FILTV;
